import React from 'react'
import useWindowSize from '../hooks/useWindowSize'

export default function ApolloIFrame({
  path,
  token,
  pinLeftNav,
}: {
  path: string
  token: string
  pinLeftNav?: boolean
}) {
  const protocol = window.location.protocol
  let host = window.location.hostname
  const port = !!window.location.port

  if (host !== 'localhost') {
    host = host.replace(/apollo/, 'main')
  }

  const src = `${protocol}//${host}${port ? ':3000' : ''}${path}?company_token=${token}`

  const { height, width } = useWindowSize(150, 80)
  return (
    <div
      style={{
        height: 'calc(100% - 130px)',
        overflowY: 'auto',
        maxWidth: '100%',
        overflowX: 'hidden',
      }}
    >
      <iframe
        title="aphrodite iframe"
        src={src}
        style={{
          border: 'none',
          width: pinLeftNav ? width - 200 : width,
          height,
          overflow: 'hidden',
        }}
      />
    </div>
  )
}
